export default __webpack_public_path__ + "static/ablobthinking-58cb5ed7df5e4c38dfcab52e1c3d645b.gif";